/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ToastConfig } from './toastConfig';
import { AppointmentSyncStartedData } from './appointmentSyncStartedData';


/**
 * WebSocket notification for appointment sync started.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface AppointmentSyncStartedNotification { 
    /**
     * Always \'appointment.sync_started\'
     */
    readonly type: string;
    data: AppointmentSyncStartedData;
    toast?: ToastConfig | null;
}
export const AppointmentSyncStartedNotification_type_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncStartedNotification_data_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const AppointmentSyncStartedNotification_toast_Validators: ValidatorFn[] =
    [ ];


